import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup} from "../../store/popupSlice" 
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Carpool App",
      slug:""
    },
  ]
}

export default function CarPoolSubhead() {
  const dispatch=useDispatch();
  const carpoolFeatureId = 'carpool-and-rideshare-software';
  return (
    <>
    <Helmet>
      <link rel="preload" href="/assets/home/car-head.webp" as="image" type="image/webp" />
    </Helmet>
    <section className="carpool-head header-gap">
      <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-7">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <h1>Premier White-Label Carpool &  <br/>
                  <span className="heading gradiant-color">Rideshare App Solution</span>
                </h1>
                <p>Build scalable intracity and outstation carpooling platforms with enterprise-grade tech.</p>
                <small>21 Days Free Trial | No Credit Card Required</small>
                <Link 
                to={`/features/${carpoolFeatureId}`}
                  className="default-btn animated-btn">
                Explore Features
              </Link>               
               <Link   onClick={() => dispatch(openPopup())} className="default-white transparent-btn animated-btn">book Demo</Link>
                <img src="./assets/home/carhead-logo.webp" className='img-responsive' alt="logo"/>
              </div>
          </div>

          <img src="/assets/home/car-head.webp" className='carhead-image' alt="car pool"/>
      </div>
    </section>
    </>
  );
}
